export const FORGOT_PASSWORD_EMAIL_SENT = 'app/ForgotPassword/FORGOT_PASSWORD_EMAIL_SENT';
export const FORGOT_PASSWORD_EMAIL_SENT_SUCCESS = 'app/PeopleProfile/FORGOT_PASSWORD_EMAIL_SENT_SUCCESS';
export const FORGOT_PASSWORD_EMAIL_ERROR = 'app/ForgotPassword/FORGOT_PASSWORD_EMAIL_ERROR';
export const CLEAR_MESSAGES = 'app/ForgotPassword/CLEAR_MESSAGES';
